import { useEffect } from "react"
import "./index.css"

const NotFound = () => {
  (function(){}(
    document.getElementsByTagName("body")[0].style.backgroundColor = "#00008b"
  ))
  return <div>
    <h1>404 Not Found</h1>
    <button>
      <a href="/">返回首页</a>
    </button>
    <div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
    </div>
  </div>
}

export default NotFound